import { Injectable } from '@angular/core';
import { BaseApiService } from '@core/services/base-api.service';
import type { UUID } from '@kerberos-compliance/compliance-shared-ts/common/types/uuid.type';
import { NamedRoleMap } from '@kerberos-compliance/compliance-shared-ts/core/iam/authorization/enums/named-role';
import type { ResponseReminderTrackerPresenceDto } from '@kerberos-compliance/compliance-shared-ts/features/reminder-tracker/dtos/response.reminder-tracker-presence.dto';

const reminderTrackerPresenceEndpoints = {
  byOrganization: (organizationId: UUID) => `reminder-tracker/by-organization/${organizationId}/presence`,
} as const;

@Injectable()
export class ReminderTrackerPresenceService extends BaseApiService {
  private readonly featureRole = NamedRoleMap.InternalUser;

  /**
   * Retrieves Risk Analysis reminder tracker presence for every delivery tracker tied to the organization.
   *
   * @param {UUID} organizationId - The organization to scope the lookup to.
   * @returns {Promise<ResponseReminderTrackerPresenceDto>} Presence data per delivery tracker.
   */
  public getRiskAnalysisPresenceByOrganization(organizationId: UUID): Promise<ResponseReminderTrackerPresenceDto> {
    return this.get<ResponseReminderTrackerPresenceDto>(
      reminderTrackerPresenceEndpoints.byOrganization(organizationId),
      this.getRequestOptions(this.featureRole),
    );
  }
}
